export enum UserRole {
  Student = 1,
  Collaborator = 2,
  Guardian = 3
}

export enum UserProfile {
  Student = 1,
  Coordinator,
  Manager,
  Operator,
  Teacher,
  Sponsor,
  Secretary,
  SchoolAdmin,
  Reviewer,
  FinancialOperator,
  OperationAdmin,
  Marketing,
  Commercial,
  Nutritionist,
  Assistant,
  Nurse,
  EducationalAdvisor,
  FinancialManager
}

export enum ProfileStrings {
  Student = "Student",
  Coordinator = "Coordinator",
  Manager = "Manager",
  Operator = "Operator",
  Teacher = "Teacher",
  Sponsor = "Sponsor",
  Secretary = "Secretary",
  SchoolAdmin = "SchoolAdmin",
  Reviewer = "Reviewer",
  FinancialOperator = "FinancialOperator",
  OperationAdmin = "OperationAdmin",
  Marketing = "Marketing",
  Commercial = "Commercial",
  Nutritionist = "Nutritionist",
  Assistant = "Assistant",
  Nurse = "Nurse",
  EducationalAdvisor = "EducationalAdvisor",
  FinancialManager = "FinancialManager"
}
